import { useFinderContext } from 'screens/Finder/FinderContext'
import { ListTree } from './ListTree'
import { TableHeaders } from './TableHeaders/TableHeaders'
import { reorderProperties } from './ListProperties'
import { DefaultType } from 'api/clients/PropertyClient'
import { CSSProperties } from 'react'
import Styles from './List.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { LoadingRows } from 'screens/RecentDocsContainer/components/FilesTable/LoadingRows'
import { ListEmptyState } from './ListEmptyState'

const List = () => {
  const { filesView } = useFinderContext()
  const { isMobile } = useResponsiveDesign()
  const files = filesView?.files

  if (!files)
    return (
      <div className={Styles.loadingRows}>
        <LoadingRows count={5} mainLoadingCellWidth={isMobile ? 'calc(100% - 40px)' : undefined} />
      </div>
    )

  if (isMobile && files.length === 0) {
    return <ListEmptyState />
  }

  const properties = filesView.schema.properties
  const orderedProperties = (properties ? reorderProperties(properties) : []).filter((prop) =>
    [DefaultType.Owner, DefaultType.Updated, DefaultType.Created].includes(prop.default_type as DefaultType),
  )

  return (
    <div style={{ '--cols-num': orderedProperties.length } as CSSProperties} className={Styles.list}>
      {!isMobile && <TableHeaders />}
      <ListTree files={files} enablePagination />
    </div>
  )
}

export { List }
